const people = {
  id: "people",
  label: "People",
  endpoint: "people",
  columnConfig: [
    {
      field: "first_name",
      headerName: "First Name",
      width: 200,
      description: "First Name",
      editable: true,
    },
    {
      field: "last_name",
      headerName: "Last Name",
      width: 200,
      description: "Last Name",
      editable: true,
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
      description: "Email",
      editable: true,
    },
    {
      field: "phone",
      headerName: "Phone",
      width: 200,
      description: "Phone",
      editable: true,
    },
    {
      field: "basins",
      headerName: "Basins",
      width: 200,
      description: "Basins",
      editable: false,
      renderCell: (params) => {
        const basins = params.row.basins;
        return basins?.map((basin) => basin.basin.name).join(", ") || "";
      },
      valueFormatter: (params) => {
        const basins = params.value;
        return basins?.map((basin) => basin.basin.name).join(", ") || "";
      },
    },
    {
      field: "projects",
      headerName: "Projects",
      width: 400,
      description: "Projects",
      editable: false,
      renderCell: (params) => {
        const projects = params.row.projects;
        return (
          projects?.map((project) => project.project.name).join(", ") || ""
        );
      },
      valueFormatter: (params) => {
        const projects = params.value;
        return (
          projects?.map((project) => project?.project?.name).join(", ") || ""
        );
      },
    },
  ],
  hiddenColumns: ["id"],
  requiredCreateFields: ["first_name", "last_name", "email", "phone"],
  chipConfig: {},
  tagConfig: {},
  sortKey: "last_name",
};

export default people;
